module.exports = __webpack_public_path__ + "img/ctms_dataSta_img4.ace7996e.png";